import React from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';

import { ComponentInstance } from '@totem/components/customDashboard/home/lib/types';

const styles = {
  removeStyle: {
    right: '3px',
    top: '7px',
    cursor: 'pointer',
    position: 'fixed' as 'fixed',
    color: '#b4b4b4',
  },
};

type Props = {
  componentInstance: ComponentInstance;
  onRemoveItem: (componentId: string) => void;
};

const WidgetRemoveButton = ({ componentInstance, onRemoveItem }: Props) => {
  return (
    <CloseCircleOutlined
      title={'Remove Widget'}
      style={styles.removeStyle}
      onClick={() => onRemoveItem(componentInstance.componentInstanceId)}
    />
  );
};

export default WidgetRemoveButton;
